<template>
  <span
    class="team-photo__caption"
  >
    <nuxt-link
      v-if="member && member.url"
      :to="member.url"
      class="country-language-selector__link"
    >
      {{ member.columns.name }},<br>
      {{ member.columns.position }}
    </nuxt-link>
    <span
      v-else-if="member && !member.url"
      class="country-language-selector__link"
    >
      {{ member.columns.name }},<br>
      {{ member.columns.position }}
    </span>
  </span>
</template>

<script>
import { Resource } from 'beisheim/models'
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  mixins: [editable],
  computed: {
    member () {
      console.dir({
        TeamPhotoItem: this.resource,
      }, { depth: 8 })
      return this.resource;
    }
  }
}
</script>
